module.exports = __webpack_public_path__ + "img/6e6f80cc0d68ad4c9aed7190358a99da.png";